var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.121 14.122"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon Arrow Right"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 747",
    d: "M1.061 1.061l6 6-6 6",
    fill: "none"
  }))));
}
export default SvgChevronRight;